import { RegionScopes } from "src/utils/region-scope";
import { backend } from "src/api";

class RegionApi {
  /**
   * 지역 트리를 조회한다. DataLake 요청 생성처럼 구조만 필요하면 CInfo 합성을 제외한다.
   */
  async getSidos(scope = RegionScopes.DEFAULT, includeCurrentInfo = true) {
    const response = await backend.get("/regions/sidos", {
      params: { scope, includeCurrentInfo },
    });
    return response.data;
  }

  async getSidosNames() {
    const response = await backend.get("/regions/sidos/names");
    return response.data;
  }

  async getGeoJson() {
    const response = await backend.get("/regions/geojson");
    return response.data;
  }
}

export const regionApi = new RegionApi();
